/**
 * Pads a number with zeroes on the left.
 *
 * @param number - the original number
 * @param numTotalDigits - the desired number of digits, including the original number
 */
module.exports = (number, numTotalDigits) => {
  const str = number.toFixed(0);
  const length = str.length;
  if (length >= numTotalDigits) {
    // Short circuit.
    return str;
  }

  const numZeroes = numTotalDigits - str.length;
  return `${Array(numZeroes).fill(0).join('')}${str}`;
}
